'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styleInject = require('../../../../../styleInject.js');

var css_248z = ".OrderLookupField-module_container__45Git{position:relative}.OrderLookupField-module_orderLookup__wlcqh{padding:.5rem .75rem;position:absolute;right:0;top:50%;transform:translateY(-50%)}.OrderLookupField-module_containerStatic__brdpL{display:flex;justify-content:space-between;padding:.625rem 0}";
var styles = {"container":"OrderLookupField-module_container__45Git","orderLookup":"OrderLookupField-module_orderLookup__wlcqh","containerStatic":"OrderLookupField-module_containerStatic__brdpL"};
styleInject["default"](css_248z, 'd3f99ba0-7ea2-4b51-937d-b8fb63182404');

exports["default"] = styles;
